import Vue from 'vue';
import CampaignModal from '@/components/common/CampaignModal.vue';
import { shouldOpenCampaign } from './campaignPopup';

let inFlight = null; // 多重起動ガード
const KEY_PREFIX = 'reech.campaign.lastSeen.';
const TZ = 'Asia/Tokyo';

// JSTのYYYYMMDD（時刻無視）
const ymd = (d = new Date()) =>
    new Intl.DateTimeFormat('ja-JP', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
        .format(d).replace(/\D/g, '');

// 'YYYYMMDD' → Date(JST 0時) / 不正は null
const parseYmd = s => /^\d{8}$/.test(s)
    ? new Date(`${s.slice(0,4)}-${s.slice(4,6)}-${s.slice(6)}T00:00:00+09:00`)
    : null;

// 月加算（暦）
const plusMonths = (d, m) => { const x = new Date(d); x.setMonth(x.getMonth() + m); return x; };

export async function runCampaignGate(slug) {
    const key = KEY_PREFIX + slug;

    // 再表示判定：不正値は削除、6か月未到来なら終了、到来済みなら旧値削除
    try {
        const raw = localStorage.getItem(key);
        if (raw) {
            const last = parseYmd(raw);
            if (!last) {
                localStorage.removeItem(key);
            } else {
                if (parseYmd(ymd()) < plusMonths(last, 6)) return;
                localStorage.removeItem(key);
            }
        }
    } catch (_) { /* no-op */ }

    if (inFlight) return inFlight; // すでに出している最中なら同じPromiseを返す

    const { open, cfg } = await shouldOpenCampaign(slug);
    if (!open) return;

    // 画像プリロード（ロード失敗ならモーダルを出さない）
    try {
        await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => reject(new Error('image load failed'));
            img.src = cfg.image;
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        // console.warn('[campaign] image preload failed:', cfg.image);
        return; // 画像がない場合はモーダルを出さずに終了
    }

    inFlight = new Promise(resolve => {
        const ModalCtor = Vue.extend(CampaignModal);
        const el = document.createElement('div');
        document.body.appendChild(el);

        const vm = new ModalCtor({
            propsData: { image: cfg.image, visible: true }
        });

        const cleanup = () => {
            try {
                vm.$destroy();
            } catch (_) { /* no-op */ }
            if (vm.$el && vm.$el.parentNode) {
                vm.$el.parentNode.removeChild(vm.$el);
            }
            inFlight = null;
            resolve();
        };

        vm.$on('close', () => {
            try { localStorage.setItem(key, ymd()); } catch (_) { /* no-op */ }
            cleanup();
        });

        vm.$mount(el);
    });

    return inFlight;
}
